import { render, staticRenderFns } from "./MaterialScanSummary.vue?vue&type=template&id=6784dbe1&scoped=true"
import script from "./MaterialScanSummary.vue?vue&type=script&lang=js"
export * from "./MaterialScanSummary.vue?vue&type=script&lang=js"
import style0 from "./MaterialScanSummary.vue?vue&type=style&index=0&id=6784dbe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784dbe1",
  null
  
)

export default component.exports